// extracted by mini-css-extract-plugin
export default {"wrapper":"mobile_action-module__wrapper--1aLYa"};